// @flow
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import PageHeader from '../../PageHeader.jsx';

import SummaryPage from './SummaryPage.jsx';
import ViewFormPage from './view/ViewFormPage.jsx';
import EditFormPage from './edit/EditFormPage.jsx';

type Props = {
  match: Object,
}

class WellChildChecksPage extends Component<Props> {
  render() {
    return (
      <div>
        <PageHeader title='Well Child Checks' />
        <Switch>
          <Route path={`${this.props.match.url}/:type/:id/view`} component={ViewFormPage} />
          <Route path={`${this.props.match.url}/:type/:id/edit`} component={EditFormPage} />
          <Route component={SummaryPage} />
        </Switch>
      </div>
    );
  }
}

export default WellChildChecksPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/WellChildChecksPage.jsx